import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function GraphRankControl({ onRank }: { onRank: (rankby: string) => void }) {
  const choices = [
    { value: "connectivity", label: "Connectivity" },
    { value: "size", label: "Size" },
    { value: "age", label: "Age" },
    { value: "freshness", label: "Freshness" },
  ];
  const [rankby, setRankby] = useState(choices[0].value);

  const handleChange = (value: string) => {
    setRankby(value);
    onRank(value);
  };

  useEffect(() => {
    onRank(choices[0].value);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 0.5,
        py: 0.5,
        borderRadius: '20px',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(232, 234, 237, 0.08)'
            : '#f1f3f4',
        flexShrink: 0,
      }}
    >
      {choices.map((choice, index) => (
        <Box key={choice.value} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            onClick={() => handleChange(choice.value)}
            sx={{
              px: 1.5,
              py: 0.5,
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
              userSelect: 'none',
              borderRadius: '16px',
              ...(rankby === choice.value
                ? {
                    backgroundColor: 'var(--surface-selected)',
                    color: 'var(--accent-primary)',
                  }
                : {
                    color: 'var(--text-secondary)',
                    '&:hover': {
                      color: 'var(--text-primary)',
                    },
                  }),
            }}
          >
            {choice.label}
          </Typography>
          {index < choices.length - 1 && rankby !== choice.value && rankby !== choices[index + 1].value && (
            <Box
              sx={{
                width: '1px',
                height: '16px',
                backgroundColor: (theme) =>
                  theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.1)'
                    : 'rgba(0, 0, 0, 0.08)',
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
